import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { setInteractionMode } from "vee-validate";
// QUINLAN
import Layout from "../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import AdminStatisticsComponent from "./components/AdminStatisticsComponent.vue";
import AnalystStatisticsComponent from "./components/AnalystStatisticsComponent.vue";
import ClientStatisticsComponent from "./components/ClientStatisticsComponent.vue";
import { SettingModule } from "@/store/modules/settings.module";
import { DashboardModule } from "@/store/modules/dashboard.module";
setInteractionMode("passive");
Component.registerHooks(["metaInfo"]);
let DashBoard = /** @class */ (() => {
    let DashBoard = class DashBoard extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            // DATA
            this.isDataLoaded = false;
            this.title = "Dashboard";
            this.items = [
                {
                    text: "Dashboard",
                },
            ];
        }
        metaInfo() {
            return {
                meta: [
                    {
                        name: "Policy Plugin",
                        content: "Quinlan description",
                    },
                    { name: "keywords", content: "product acceleration platform, " },
                ],
                title: "Policy Plugin - DashBoard",
            };
        }
        get isAdmin() {
            return SettingModule.userRole == this.admin;
        }
        get isAnalyst() {
            return SettingModule.userRole == this.analyst;
        }
        get isClient() {
            return SettingModule.userRole == this.client;
        }
        get getStatisticsComponent() {
            if (this.isAdmin) {
                return "AdminStatisticsComponent";
            }
            else if (this.isAnalyst) {
                return "AnalystStatisticsComponent";
            }
            else if (this.isClient) {
                return "ClientStatisticsComponent";
            }
        }
        get isPageLoading() {
            return DashboardModule.isPageLoading;
        }
        // // LIFECYCLE
        created() {
            DashboardModule.SetIsPageLoading(true);
            DashboardModule.GetDashboardDetails().then((response) => {
                this.isDataLoaded = true;
                DashboardModule.SetIsPageLoading(false);
            });
        }
    };
    DashBoard = __decorate([
        Component({
            name: "DashBoard",
            components: {
                Layout,
                PageHeader,
                Loader,
                AdminStatisticsComponent,
                AnalystStatisticsComponent,
                ClientStatisticsComponent,
            },
        })
    ], DashBoard);
    return DashBoard;
})();
export default DashBoard;
